export const SIPARIS_DURUM = {
  TESLIMAT_BEKLENIYOR: 3,
  TESLIM_EDILDI: 6,
  MUSTERI_IPTALI: 7,
  CAGRI_MERKEZI_IPTALI: 10,
  TESLIM_EDILEMEDI: 11,
};
